import React from "react";
import { Translation } from "react-i18next";
import graphPlaceholder from "../../assets/trend.png";
import * as CONSTANTS from "../../utilities/Constants";

interface INoTrendToDisplayProps {
    message?: string;
}

export default class NoTrendToDisplay extends React.Component<INoTrendToDisplayProps, {}> {
    private _mount: boolean = false;

    constructor(props: INoTrendToDisplayProps) {
        super(props);
        this._mount = true;

    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {
        this._mount = true;
    }

    public render() {

        return (
            <React.Fragment>
                <div>
                    <Translation>
                        {
                            t =>
                                <div className="text-center">
                                    <div className="" >
                                        <img src={graphPlaceholder} alt="" />
                                        <div>
                                            {t(this.props.message ? this.props.message : CONSTANTS.NO_TREND_DISPLAY)}
                                        </div>
                                    </div>
                                </div>
                        }
                    </Translation>
                </div>
            </React.Fragment>
        );
    }
}
